import React from 'react';
import { NewStripContainer } from './styled';

function NewStrip(props) {
  const {
    offerData,
    marqueeTextArray,
    leftPadding,
    bgColor,
    textColor,
    text,
    showNewUi,
  } = props;
  let code = 'FIRST10';
  const marqueeElements = (showNewUi = false) => {
    if (marqueeTextArray?.length) {
      return marqueeTextArray.map((text, index) => (
        <span key={index}>{text}</span>
      ));
    } else if (text) {
      return <span>{text}</span>;
    } else {
      const code = offerData?.[0]?.code || 'FIRST10'; // Ensure fallback value
      return showNewUi ? (
        <>
          <span className="newOfferStrip">
            <div>Get extra 15% OFF on Babycare range..</div>
            <div className="copyCodeBtn">
              <div
                style={{
                  padding: '2px 4px',
                  fontWeight: '300',
                  backgroundColor: 'rgba(255, 255, 255, 0.2)',
                }}
              >
                CODE:
              </div>
              <div
                style={{
                  padding: '2px 4px',
                }}
              >
                {code}
              </div>
            </div>
          </span>
        </>
      ) : (
        <>
          <span>
            This changing weather, protect your family with big discounts! Use
            code: <b>{code}</b>
          </span>
          <span className="hideForDesktop">
            This changing weather, protect your family with big discounts! Use
            code: <b>{code}</b>
          </span>
        </>
      );
    }
    // return <span>No offers available</span>; // Always return something
  }; //, [marqueeTextArray, offerData]);

  return (
    <NewStripContainer
      leftPadding={leftPadding}
      bgColor={bgColor}
      textColor={textColor}
      showNewUi={showNewUi}
    >
      <div className="marquee">
        <div className="marquee-content">{marqueeElements(showNewUi)}</div>
      </div>
    </NewStripContainer>
  );
}

export default NewStrip;
